export default {
  text: 'Kartan tarjoaa Google. Sen lataaminen lähettää IP-osoitteesi Googlelle.',
  buttons: {
    show_map: 'Näytä kartta',
    retry: 'Yritä uudelleen',
  },
  errors: {
    map_unavailable: 'Kartan lataaminen epäonnistui.',
  },
};
